import api from "@helpers/api";

import { URLS } from "@constants/urls";

import {
  PostingsType,
  AbroadPostingType,
  DeputationPostingType,
  PostingRecordPostingType,
  ForeignTravelPostingType,
} from "@type/HRM/postings";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}`;

export const getPostings = (() => {
  return async (data: { data: string }): Promise<{ data: PostingsType }> => {
    const id = data.data; // employee id
    return api
      .get(`${apiEndPoint}/${URLS.EMPLOYEES}/${id}/posting-info`)
      .then((response) => ({ data: response.data }));
  };
})();

export const updateAbroadPostingInfo = (() => {
  return async (data: {
    data: AbroadPostingType;
  }): Promise<{ data: AbroadPostingType }> => {
    const { id, ...rest } = data.data;
    const { employeeID } = rest;

    const action = id ? "put" : "post";

    const putUrl = `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/posting-abroad/${id}`;
    const postUrl = `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/posting-abroad`;
    const url = id ? putUrl : postUrl;

    return api[action](url, { ...rest }).then((response) => ({
      data: response.data,
    }));
  };
})();

export const updateDeputationPostingInfo = (() => {
  return async (data: {
    data: DeputationPostingType;
  }): Promise<{ data: DeputationPostingType }> => {
    const { id, ...rest } = data.data;
    const { employeeID } = rest;

    const action = id ? "put" : "post";

    const putUrl = `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/deputation-posting/${id}`;
    const postUrl = `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/deputation-posting`;
    const url = id ? putUrl : postUrl;

    return api[action](url, { ...rest }).then((response) => ({
      data: response.data,
    }));
  };
})();

export const updatePostingRecordPostingInfo = (() => {
  return async (data: {
    data: PostingRecordPostingType;
  }): Promise<{ data: PostingRecordPostingType }> => {
    const { id, ...rest } = data.data;
    const { employeeID } = rest;

    const action = id ? "put" : "post";

    const putUrl = `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/posting-records/${id}`;
    const postUrl = `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/posting-records`;
    const url = id ? putUrl : postUrl;

    return api[action](url, { ...rest }).then((response) => ({
      data: response.data,
    }));
  };
})();

export const updateForeignTravelPostingInfo = (() => {
  return async (data: {
    data: ForeignTravelPostingType;
  }): Promise<{ data: ForeignTravelPostingType }> => {
    const { id, ...rest } = data.data;
    const { employeeID } = rest;

    const action = id ? "put" : "post";

    const putUrl = `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/foreign-travel/${id}`;
    const postUrl = `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/foreign-travel`;
    const url = id ? putUrl : postUrl;

    return api[action](url, { ...rest }).then((response) => ({
      data: response.data,
    }));
  };
})();

export const deleteAbroadPostingInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; abroadPostingID: number };
  }): Promise<{ data: { id: number } }> => {
    const { abroadPostingID, employeeID } = data.data;

    return api
      .delete(
        `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/posting-abroad/${abroadPostingID}`,
      )
      .then(() => ({ data: { id: abroadPostingID } }));
  };
})();

export const deleteDeputationPostingInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; deputationPostingID: number };
  }): Promise<{ data: { id: number } }> => {
    const { deputationPostingID, employeeID } = data.data;

    return api
      .delete(
        `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/deputation-posting/${deputationPostingID}`,
      )
      .then(() => ({ data: { id: deputationPostingID } }));
  };
})();

export const deletePostingRecordPostingInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; postingRecordPostingID: number };
  }): Promise<{ data: { id: number } }> => {
    const { postingRecordPostingID, employeeID } = data.data;

    return api
      .delete(
        `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/posting-records/${postingRecordPostingID}`,
      )
      .then(() => ({ data: { id: postingRecordPostingID } }));
  };
})();

export const deleteForeignTravelPostingInfo = (() => {
  return async (data: {
    data: { employeeID: number | null; foreignTravelPostingID: number };
  }): Promise<{ data: { id: number } }> => {
    const { foreignTravelPostingID, employeeID } = data.data;

    return api
      .delete(
        `${apiEndPoint}/${URLS.EMPLOYEES}/${employeeID}/posting-info/foreign-travel/${foreignTravelPostingID}`,
      )
      .then(() => ({ data: { id: foreignTravelPostingID } }));
  };
})();
